import i18n from "i18next";
import detector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import ko from "./langs/ko";
import en from "./langs/en";
import zhTw from "./langs/zh-TW";
import zhCn from "./langs/zh-CN";
import ja from "./langs/ja";
import es from "./langs/es";
import fr from "./langs/fr";
import de from "./langs/de";
import ru from "./langs/ru";

const resources = {
  ko: { translation: ko },
  en: { translation: en },
  "zh-TW": { translation: zhTw },
  "zh-CN": { translation: zhCn },
  ja: { translation: ja },
  es: { translation: es },
  fr: { translation: fr },
  de: { translation: de },
  ru: { translation: ru },
};

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    keySeparator: ".",
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;